import { raundColors } from '@/theme/colors'
import type React from 'react'
import styles from './FormField.module.css'
import { Typography } from './Typography'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type FormFieldLabelStatus = 'normal' | 'danger'

export type FormFieldProps = {
  /** 入力の上部に表示するラベル */
  label?: string
  /** ラベルの色状態（normal=黒, danger=赤） */
  labelStatus?: FormFieldLabelStatus
  /** エラーメッセージ（表示すると danger 色） */
  error?: string
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
export const FormField = ({ label, labelStatus = 'normal', error, children, style, className }: FormFieldProps) => {
  return (
    <div className={`${styles.root} ${className ?? ''}`} style={style}>
      {label && (
        <Typography
          variant="caption1"
          component="span"
          className={styles.label}
          c={labelStatus === 'danger' ? raundColors.danger.base : raundColors.black}
        >
          {label}
        </Typography>
      )}
      <div className={styles.content}>{children}</div>
      {error && (
        <Typography variant="caption1" component="span" className={styles.error}>
          {error}
        </Typography>
      )}
    </div>
  )
}
